import { useCallback, useEffect, useState } from "react";

import { entitlementGateway } from "../../gateways/entitlementGateway";
import type {
  EffectiveEntitlement,
  ProductCatalog,
  UsageBalance,
} from "../../types/auth";

interface EntitlementState {
  loading: boolean;
  balance: UsageBalance | null;
  catalog: ProductCatalog | null;
  effective: EffectiveEntitlement | null;
  error: string | null;
}

const INITIAL_STATE: EntitlementState = {
  loading: true,
  balance: null,
  catalog: null,
  effective: null,
  error: null,
};

export function useEntitlements() {
  const [state, setState] = useState<EntitlementState>(INITIAL_STATE);
  const [requestVersion, setRequestVersion] = useState(0);

  useEffect(() => {
    let active = true;
    void entitlementGateway
      .getSummary()
      .then(({ balance, catalog, effective }) => {
        if (active) {
          setState({
            loading: false,
            balance,
            catalog,
            effective,
            error: null,
          });
        }
      })
      .catch(() => {
        if (active) {
          setState({
            loading: false,
            balance: null,
            catalog: null,
            effective: null,
            error: "Your trial details are temporarily unavailable.",
          });
        }
      });
    return () => {
      active = false;
    };
  }, [requestVersion]);

  const retry = useCallback(() => {
    setState(INITIAL_STATE);
    setRequestVersion((version) => version + 1);
  }, []);

  return { ...state, retry };
}
